export default "__VITE_ASSET__CPwm0_SI__"